function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(250, 250, 250)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'bla': 'rgb(117, 189, 206)','orange': 'rgb(247, 96, 53)','gul': 'rgb(229, 203, 41)',};

    this.images = {'oliv': 'url("//barista-espresso.se/cdn/shop/files/Oliv_68x.png?v=1639721262416978269")','valnot': 'url("//barista-espresso.se/cdn/shop/files/Walnot_68x.png?v=2545317508082278332")','ek': 'url("//barista-espresso.se/cdn/shop/files/Ek_68x.png?v=11516722490502404009")','svart-ek': 'url("//barista-espresso.se/cdn/shop/files/Dark_ek_68x.png?v=17145392210145937616")','svart': 'url("//barista-espresso.se/cdn/shop/files/Matt_black_68x.png?v=479088389897090137")','rostfritt-stal': 'url("//barista-espresso.se/cdn/shop/files/Stainless_brushed_68x.png?v=11175252152249228786")','gra': 'url("//barista-espresso.se/cdn/shop/files/Stainless_grey_68x.png?v=3411980566487842347")','premium-wood': 'url("//barista-espresso.se/cdn/shop/files/Premium_wood_68x.png?v=9426556980261732457")','premium-krom': 'url("//barista-espresso.se/cdn/shop/files/Premium_krom_68x.png?v=1596010472626031369")','rostfritt': 'url("//barista-espresso.se/cdn/shop/files/Stainless_brushed_68x.png?v=11175252152249228786")','satin-svart': 'url("//barista-espresso.se/cdn/shop/files/Satin_svart_68x.png?v=15249560020251847145")','satin-green': 'url("//barista-espresso.se/cdn/shop/files/Satin_green_68x.png?v=10778448944946127231")','svart-koppar': 'url("//barista-espresso.se/cdn/shop/files/svart_koppar_68x.jpg?v=12813784420633933431")','krom-koppar': 'url("//barista-espresso.se/cdn/shop/files/Krom_Koppar_68x.jpg?v=9442087697829497798")','krom-svart': 'url("//barista-espresso.se/cdn/shop/files/Krom_Svart_68x.jpg?v=15995996464697240448")','krom-vit': 'url("//barista-espresso.se/cdn/shop/files/Krom_Vit_68x.jpg?v=2332675201016966648")','svart-vit': 'url("//barista-espresso.se/cdn/shop/files/Svart_Vit_68x.jpg?v=15995996464697240448")','rod': 'url("//barista-espresso.se/cdn/shop/files/rod_68x.jpg?v=7241794094714490221")','stainless_brushed-png': 'url("//barista-espresso.se/cdn/shop/files/Stainless_brushed_68x.png?v=11175252152249228786")','krom': 'url("//barista-espresso.se/cdn/shop/files/Stainless_brushed_68x.png?v=11175252152249228786")','matt-svart': 'url("//barista-espresso.se/cdn/shop/files/Satin_svart_68x.png?v=15249560020251847145")','gron': 'url("//barista-espresso.se/cdn/shop/files/Gron_68x.jpg?v=1905998427594719612")','beige': 'url("//barista-espresso.se/cdn/shop/files/Beige_68x.jpg?v=10440257004657940595")','satin-black': 'url("//barista-espresso.se/cdn/shop/files/Matt_black_68x.png?v=479088389897090137")','satin-grey': 'url("//barista-espresso.se/cdn/shop/files/Satin_Grey_68x.jpg?v=10871672057763338792")','svart-rostfritt': 'url("//barista-espresso.se/cdn/shop/files/Svart_rostfritt_68x.jpg?v=7647566855674924706")','svart-tra': 'url("//barista-espresso.se/cdn/shop/files/Svart_Tra_68x.jpg?v=16520295487088719736")','olive': 'url("//barista-espresso.se/cdn/shop/files/Oliv_68x.png?v=1639721262416978269")','walnuss': 'url("//barista-espresso.se/cdn/shop/files/Walnot_68x.png?v=2545317508082278332")','eiche': 'url("//barista-espresso.se/cdn/shop/files/Ek_68x.png?v=11516722490502404009")','schwarzeiche': 'url("//barista-espresso.se/cdn/shop/files/Dark_ek_68x.png?v=17145392210145937616")',};

    this.triggers = ['träslag','färg',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
